<template>
  <b-container class="game">
    <b-row align-h="center" class="title text-center">
      <b-col lg="6">
        <div class="room-name">Sala <b>{{room.name}}</b></div>
        <div class="game-name">Partida <b>{{game.name}}</b></div>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col lg="6">
        <b-card class="info">
          <b-card-text>
            <h5><b>Cartones</b></h5>
          </b-card-text>
          <b-card-text>
            <div>Precio del cartón: <b>{{game.costPerTicket}}€</b></div>
            <div>Vendidos: <b>{{game.assignedTickets.length}}</b></div>
          </b-card-text>
          <b-card-text>
            <h5><b>Premios</b></h5>
          </b-card-text>
          <b-card-text>
            <div class="d-flex justify-content-between">
              <span>Línea: <b>{{ getLinePrize(game) }}€</b> ({{game.prizesDistribution}}%)</span>
              <span v-for="(winner, idx) in game.lineClaims" :key="winner.userId">
                <span v-if="game.lineClaims.length > 1 && idx > 0">, </span>
                {{getUser(winner.userId).username}}
              </span>
            </div>
            <div class="d-flex justify-content-between">
              <span>Bingo: <b>{{ getBingoPrize(game) }}€</b> ({{100 - game.prizesDistribution}}%)</span>
              <span v-for="(winner, idx) in game.bingoClaims" :key="winner.userId">
                <span v-if="game.bingoClaims.length > 1 && idx > 0">, </span>
                {{getUser(winner.userId).username}}
              </span>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col lg="6">
        <b-card no-body header="Participantes" class="card-list">
          <b-list-group flush>
            <b-list-group-item v-if="game.participants.length === 0">
              Sin participantes
            </b-list-group-item>
            <b-list-group-item
              v-for="participant in game.participants" v-bind:key="participant.uid"
              class="d-flex justify-content-between align-items-center">
              {{ participant.username || participant.displayName }}
              <span v-if="isMe(participant.uid) && !isMe(room.userId)">
                <b-badge variant="success"><b-icon icon="person-fill"></b-icon></b-badge>
              </span>
              <span v-if="isMe(participant.uid) && isMe(room.userId)">
                <b-badge variant="success">Admin <b-icon icon="person-fill"></b-icon></b-badge>
              </span>
              <span v-if="room.userId === participant.uid && !isMe(participant.uid)">
                <b-badge variant="success">Admin</b-badge>
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col lg="6">
        <b-button class="w-100" @click="joinGame" :disabled="(game.numbers.length > 0 && game.participantIds.indexOf(currentUser.uid) === -1) || game.bingoClaims.length > 0">Unirse a la Partida</b-button>
      </b-col>
    </b-row>
    <!-- Buy Tickets -->
    <b-row align-v="center" align-h="center" class="overlay text-center" v-if="showJoinGame">
      <b-col lg="5" md="6">
        <b-card>
          <h5>¿Cuantos cartones quieres? 😏</h5>
          <div class="ticket-counter">
            <b-button variant="outline-success" class="operator" :disabled="numberOfTickets > 5" @click="numberOfTickets++">
              <b-icon font-scale="2" icon="plus"></b-icon>
            </b-button>
            <span class="number">
              {{ numberOfTickets }}
            </span>
            <b-button variant="outline-danger" class="operator" :disabled="numberOfTickets < 2" @click="numberOfTickets--">
              <b-icon font-scale="2" icon="dash"></b-icon>
            </b-button>
          </div>
          <b-button class="bottom" @click="showJoinGame = false" variant="danger">Cancelar</b-button>
          <b-button class="bottom" @click="buyTicketsAndJoin" variant="primary">Unirse</b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "game",
  data() {
    return {
      users: [],
      showJoinGame: false,
      numberOfTickets: 1,
    };
  },
  computed: {
    ...mapState(['currentUser', 'socketConnected', 'game', 'room'])
  },
  watch: {
    socketConnected: {
      handler(connected) {
        if (connected) {
          console.log("Restored connection with sockets server");
          this.$socket.emit('joinGame', this.$route.params.gameId);
        } else {
          console.log("Disconnected from sockets server");
        }
      }
    }
  },
  mounted() {
    this.$socket.emit('joinGame', this.$route.params.gameId);
    this.$socket.emit('joinRoom', this.$route.params.roomId);
  },
  beforeDestroy() {
    this.$socket.emit('leaveGame', this.$route.params.gameId);
    this.$socket.emit('leaveRoom', this.$route.params.roomId);
  },
  methods: {
    getUser(userId) {
      let user = this.game.participants.filter((participant) => participant.uid === userId);
      return user.length ? user[0]: {}
    },
    compareTickets(a, b) {
      let comparison = 0;
      if (a.serieId > b.serieId) {
        comparison = 1;
      } else if (a.serieId < b.serieId) {
        comparison = -1;
      }
      return comparison;
    },
    async buyTicketsAndJoin() {
      try {
        let response = await this.$http.post(`${process.env.VUE_APP_API_URL}/buy-tickets`, {
          gameId: this.game.id,
          userId: this.currentUser.uid,
          amount: this.numberOfTickets
        });
        let data = await response.data;
        if (data.success) {
          this.goToPlayGame(this.game.id);
        } else {
          throw new Error("Cannot buy tickets")
        }
      } catch (error) {
        console.error("Error buying tickets", error);
      }
    },
    isMe(userId) {
      return userId === this.currentUser.uid;
    },
    goToPlayGame(gameId) {
      this.$router.push({
        name: 'play-game',
        params: { gameId }
      })
    },
    joinGame() {
      const mytickets = this.game.assignedTickets.filter(a => {
        return a.userId === this.currentUser.uid;
      })
      if (mytickets.length > 0) {
        this.goToPlayGame(this.game.id);
      } else {
        this.showJoinGame = true;
      }
    },
    getBingoPrize(game) {
      return game.assignedTickets.length ? (game.assignedTickets.length * game.costPerTicket) * (100 - game.prizesDistribution) / 100 : 0;
    },
    getLinePrize(game) {
      return game.assignedTickets.length ? (game.assignedTickets.length * game.costPerTicket) * (game.prizesDistribution) / 100 : 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.game {
  margin-bottom: 30px;
}
.title {
  margin-bottom: 20px;
}
.room-name {
  font-size: 21px;
}
.game-name {
  font-size: 30px;
}
.card {
  margin-bottom: 20px;
}
.overlay {
  position: fixed;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
button.operator {
  padding: 0;
  width: 46px;
  height: 46px;
  border-radius: 23px;
  margin: 0 15px 15px 15px;
}
.bottom {
  margin: 0 5px;
}
.ticket-counter {
  margin: 30px 0;
  .number {
    font-size: 40px;
  }
}
</style>